module.exports = __webpack_public_path__ + "img/용산역 와인.a4163521.png";